import { getConfig } from '~/utils/helpers'

export default function settings({ context }) {
  const devUrl = 'https://staging18.staging.gb.ru/api/v2'
  const prodUrl = 'https://gb.ru/api/v2'
  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
    async getConfirmationCode(phone) {
      try {
        const response = await context.$axios.post(`${baseUrl}/profile/phone/send_confirmation`,
          { phone },
          getConfig(context.$jwt())
        )

        return { response }
      } catch (e) {
        console.warn(e)

        return { error: true, response: e.response }
      }
    },

    async confirmPhone(token) {
      try {
        const response = await context.$axios.put(`${baseUrl}/profile/phone/confirm`,
          { token },
          getConfig(context.$jwt())
        )

        return { response }
      } catch (e) {
        console.warn(e)

        return { error: true, response: e.response }
      }
    },

    async fetchSettingsData() {
      try {
        const { data } = await context.$axios.get(`${baseUrl}/notification_settings`, { useCache: false, ...getConfig(context.$jwt()) })

        return data
      } catch (e) {
        console.warn(e)
      }
    },

    async saveSettings() {
      try {
        const { activeSettings } = context.store.state.settings
        await context.$axios.post(`${baseUrl}/notification_settings`, { notification_settings: activeSettings }, getConfig(context.$jwt()))
      } catch (e) {
        console.warn(e)
      }
    },

    async assignTelegram(user) {
      try {
        const { telegramData } = context.store.state.settings

        if (telegramData?.assign_telegram_link && user) {
          const requestData = new FormData()

          for ( const key in user ) {
            requestData.append(key, user[key])
          }

          return await context.$axios.post(telegramData.assign_telegram_link, requestData)
        }
      } catch (e) {
        console.warn(e)
      }
    },

    async deassignTelegram() {
      try {
        const { telegramData } = context.store.state.settings

        if (telegramData?.deassign_telegram_link) {
          return await context.$axios.post(telegramData.deassign_telegram_link)
        }
      } catch (e) {
        console.warn(e)
      }
    }
  }
}
